import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent extends BaseDialogComponent {
  public uploadedImage: any = {};

  constructor(public activeModal: NgbActiveModal, injector: Injector) {
    super(injector);
  }

  closeModal() {
      this.activeModal.dismiss();
  }
}
